interface ResolutionBadgeProps {
  resolution: string;
}

export function ResolutionBadge({ resolution }: ResolutionBadgeProps) {
  return (
    <div className="text-xs h-5 leading-5 px-1 bg-white text-[rgba(15,19,36,0.6)] border border-[rgba(10,15,41,0.08)] rounded-sm">
      {resolution}
    </div>
  );
}
